import ReactRootProviders from '@app/contexts/providers/ReactRootProviders';
import ShipmentsEmptyState from '@app/pages/shipments/components/EmptyState';
import React from 'react';
import { react2angular } from 'react2angular';

function WrappedShipmentsEmptyState() {
  return (
    <ReactRootProviders>
      <ShipmentsEmptyState />
    </ReactRootProviders>
  );
}

const AngularShipmentsEmptyState = react2angular(WrappedShipmentsEmptyState, [], []);

export default AngularShipmentsEmptyState;
